$('.slider__container').slick({
  autoplay: true,
  arrows: false,
  dots: true,
  fade: true
});
